import React from 'react';
export function Hero() {
  return <div className="mb-8" data-id="element-74">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6 font-sans" data-id="element-75">
        After Treating 2,000+ Patients, This Doctor Discovered Why{' '}
        <span className="bg-[#FEF3C7] px-1" data-id="element-76">
          Willpower Never Works for Nightly Drinking
        </span>
      </h1>
    </div>;
}